// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"222":"3809d9e3","330":"7f9e8d42","488":"a228e329","492":"256e0731","495":"67d1c6cc","548":"13ff2d35","607":"732a914d","885":"4c01cc1f"}[chunkId] + ".chunk.js";
};